module.exports = __webpack_public_path__ + "static/media/c3bannerModul1_small.5f39e594.jpg";